import { Helmet } from "react-helmet";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonTop from "shared/Button/ButtonTop";

const SnKPost = () => {
  const renderContent = () => {
    return (
      <div
        id="single-entry-content"
        className="prose prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
      >
        <h1>Syarat dan Ketentuan Rentrips</h1>
        <p>
          Hi Kamu! Selamat datang di situs Rentrips.id yang merupakan situs
          rental marketplace yang akan membuat liburanmu menjadi lebih praktis
          dan menyenangkan! Dengan mengakses situs www.rentrips.id, kamu
          diharapkan sudah membaca dengan seksama mengenai Ketentuan Penggunaan
          karena bisa berdampak pada Vendor maupun User secara hukum.
        </p>{" "}
        <p>
          Dengan mendaftar dan/atau menggunakan layanan di situs
          www.rentrips.id, maka kamu dianggap telah membaca, mengerti, memahami
          dan menyetujui segala hal yang tercantum pada Syarat dan Ketentuan.
          Syarat dan Ketentuan ini merupakan bentuk kesepakatan antara Vendor,
          User dengan pihak Rentrips.id. Jika kamu tidak menyetujui satu,
          Sebagian atau seluruh isi dari Syarat dan Ketentuan, maka kamu tidak
          diperkenankan untuk mendaftar dan/atau menggunakan layanan di situs
          www.rentrips.id.
        </p>
        {/** APA ITU RENTRIPS */}
        <h3 className=" mt-3">Apa itu Rentrips.id</h3>
        <ol>
          <li>
            <span>
              {" "}
              Rentrips.id merupakan sebuah situs rental marketplace yang
              menyediakan segala macam barang yang bisa membantu membuat liburan
              kamu menjadi lebih praktis dan menyenangkan.
            </span>
          </li>
          <li>
            <span> Situs Rentrips.id adalah </span>
            <a href="http://www.rentrips.id">
              <span>www.rentrips.id</span>
            </a>
          </li>
          <li>
            <span>
              {" "}
              Syarat dan Ketentuan adalah perjanjian antara Vendor maupun user
              dengan pihak Rentrips.id yang berisi seperangkat peraturan yang
              memuat hak, kewajiban, tanggung jawab pengguna dan Rentrips.id,
              serta tata cara penggunaan sistem layanan di situs{" "}
            </span>
            <a href="http://www.rentrips.id">
              <span>www.rentrips.id</span>
            </a>
          </li>
          <li>
            <span>
              {" "}
              Vendor merupakan pihak yang menyewakan barang dan user merupakan
              pihak yang menyewa barang, selanjutnya vendor dan user merupakan
              pengguna layanan Rentrips.id
            </span>
          </li>
          <li>
            <span>
              {" "}
              User atau pengguna merupakan pihak yang terdaftar di situs{" "}
            </span>
            <a href="http://www.rentrips.id">
              <span>www.rentrips.id</span>
            </a>
            <span>
              {" "}
              yang menyewa barang yang disewakan oleh Vendor/pihak yang
              menyewakan barang di website Rentrips.id
            </span>
          </li>
          <li>
            <span>
              {" "}
              Vendor atau pihak yang menyewakan barang merupakan pihak yang
              terdaftar di situs{" "}
            </span>
            <a href="http://www.rentrips.id">
              <span>www.rentrips.id</span>
            </a>
            <span>
              {" "}
              yang menyediakan barang untuk disewakan kepada user Rentrips.id
            </span>
          </li>
          <li>
            <span>
              {" "}
              Barang adalah benda yang berwujud/memiliki wujud fisik dan
              memenuhi kriteria barang yang boleh disewakan di situs{" "}
            </span>
            <a href="http://www.rentrips.id">
              <span>www.rentrips.id</span>
            </a>
          </li>
        </ol>
        {/** AKUN, PASSWORD DAN KEMANAN */}
        <h3 className=" mt-3">Akun, Password, dan Keamanan</h3>
        <ol>
          <li>
            <span>
              {" "}
              Pengguna menyatakan bahwa ia adalah orang yang cakap dan mampu
              berkomitmen dalam sebuah perjanjian yang sah menurut hukum.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips.id tidak memungut biaya pendaftaran apapun maupun iklan
              kepada pengguna.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pengguna memahami bahwa 1 (satu) data hanya bisa digunakan untuk
              mendaftar 1 (satu) akun Rentrips.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pengguna yang telah mendaftar berhak berperan sebagai
              Vendor/penyedia barang sewa maupun user/penyewa.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pengguna yang memilih bertindak sebagai vendor diharapkan untuk
              mengunggah konten produk yang akan disewakan agar bisa segera
              melakukan transaksi sewa menyewa di situs{" "}
            </span>
            <a href="http://www.rentrips.id">
              <span>www.rentrips.id</span>
            </a>
          </li>
          <li>
            <span>
              {" "}
              Rentrips tanpa pemberitahuan terlebih dahulu kepada Pengguna,
              memiliki kewenangan untuk melakukan tindakan yang perlu atas
              setiap dugaan pelanggaran atau pelanggaran Syarat &amp; ketentuan
              dan/atau hukum yang berlaku, yakni tindakan berupa moderasi toko,
              penutupan toko, pembatalan listing, suspensi akun, dan/atau
              penghapusan akun pengguna.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips memiliki kewenangan untuk melakukan penyesuaian jumlah
              transaksi toko, penyesuaian jumlah reputasi, dan/atau melakukan
              proses moderasi/menutup akun Pengguna, jika diketahui atau diduga
              adanya kecurangan atau manipulasi data transaksi demi meningkatkan
              reputasi toko (review dan atau jumlah transaksi). Contohnya adalah
              melakukan proses sewa ke toko sendiri dengan menggunakan akun
              pribadi atau akun pribadi lainnya.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips memiliki kewenangan untuk menutup toko atau akun Pengguna
              baik sementara maupun permanen apabila didapati adanya tindakan
              kecurangan dalam bertransaksi, pelanggaran terhadap Syarat dan
              Ketentuan. Pengguna menyetujui bahwa Rentrips berhak melakukan
              tindakan lain yang diperlukan terkait hal tersebut, termasuk namun
              tidak terbatas pada menolak pengajuan pembukaan toko/akun yang
              baru apabila ditemukan kesamaan data.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pengguna dilarang untuk menciptakan dan/atau menggunakan
              perangkat, software, fitur dan/atau alat lainnya yang bertujuan
              untuk melakukan manipulasi pada sistem Rentrips, seperti
              manipulasi data Toko ataupun aktivitas lain yang secara wajar
              dapat dinilai sebagai tindakan manipulasi sistem.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Vendor dilarang untuk menduplikasi toko maupun produk atau
              berbagai macam tindakan yang mengindikasikan persaingan tidak
              sehat.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Vendor dan User bertanggung jawab secara pribadi atas kerahasiaan
              akun maupun password untuk semua aktivitas yang terjadi di dalam
              akun.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pihak Rentrips tidak meminta username, password maupun kode sms
              verifikasi atau kode OTP milik akun pengguna untuk keperluan
              apapun, oleh karena itu pihak Rentrips menghimbau agar pengguna
              tidak memberikan data tersebut maupun data lainnya kepada pihak
              yang mengatasnamakan Rentrips atau pihak lain.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pengguna setuju untuk memastikan bahwa Pengguna keluar dari akun
              di akhir setiap sesi dan memberitahu Pihak Rentrips jika ada
              penggunaan tanpa izin atas sandi atau akun Pengguna.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pengguna dengan ini menyatakan bahwa Rentrips tidak bertanggung
              jawab atas kerugian ataupun kendala yang timbul atas
              penyalahgunaan akun Pengguna yang diakibatkan oleh kelalaian
              Pengguna, termasuk namun tidak terbatas pada meminjamkan atau
              memberikan akses akun kepada pihak lain, mengakses link atau
              tautan yang diberikan oleh pihak lain, memberikan atau
              memperlihatkan kode verifikasi (OTP), password atau email kepada
              pihak lain, maupun kelalaian Pengguna lainnya yang mengakibatkan
              kerugian ataupun kendala pada akun Pengguna.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips tidak bertanggung jawab atas segala macam transaksi yang
              dilakukan vendor di luar situs Rentrips.
            </span>
          </li>
        </ol>
        {/** TRANSAKSI SEWA MENYEWA */}
        <h3 className=" mt-3">Transaksi Sewa Menyewa</h3>
        <ol>
          <li>
            <span>
              {" "}
              User wajib bertransaksi melalui prosedur transaksi yang telah
              ditetapkan oleh Rentrips dan melakukan pembayaran dengan
              menggunakan metode pembayaran yang sebelumnya telah dipilih oleh
              User, dan kemudian Rentrips akan meneruskan dana ke pihak Vendor
              apabila tahapan transaksi sewa-menyewa pada sistem Rentrips telah
              selesai.
            </span>
          </li>
          <li>
            <span> Saat melakukan sewa, User menyetujui bahwa: </span>
            <ul>
              <li>
                <span>
                  {" "}
                  User bertanggung jawab untuk membaca, memahami, dan menyetujui
                  informasi/deskripsi keseluruhan barang termasuk ketentuan Toko
                  didalamnya sebelum membuat komitmen untuk menyewa dan
                  melakukan pembayaran.
                </span>
              </li>
              <li>
                <span>
                  {" "}
                  User mengakui bahwa warna sebenarnya dari produk sebagaimana
                  terlihat di foto yang tayang pada website Rentrips, tergantung
                  pada monitor komputer User. Rentrips telah melakukan upaya
                  terbaik untuk memastikan warna dalam foto-foto yang
                  ditampilkan pada website Rentrips muncul seakurat mungkin, dan
                  baik Vendor maupun User masuk ke dalam kontrak yang mengikat
                  secara hukum saat bertransaksi.
                </span>
              </li>
              <li>
                <span>
                  {" "}
                  Rentrips tidak mengalihkan kepemilikan secara hukum atas
                  barang-barang dari Vendor kepada User.
                </span>
              </li>
            </ul>
          </li>
          <li>
            <span>
              {" "}
              User memahami dan menyetujui bahwa ketersediaan stok Barang
              merupakan tanggung jawab Vendor. Rentrips menghimbau kepada Vendor
              agar hanya menayangkan barang yang siap untuk disewakan dan selalu
              memperbarui stok pada Pengaturan Stok di halaman akun Vendor.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Penolakan pesanan atau tidak melakukan konfirmasi dapat
              menimbulkan konsekuensi seperti penurunan reputasi pada toko,
              penghapusan listing dari kategori produk popular, sampai pada
              pemblokiran akun vendor apabila dilakukan lebih dari 3 kali per
              tahunnya.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pembatalan pesanan setelah menerima pesanan atau melakukan
              konfirmasi akan menimbulkan biaya layanan, penurunan reputasi pada
              toko, penghapusan listing dari kategori produk popular, sampai
              pada pemblokiran akun.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Vendor dapat mengatur jenis pesanan untuk mengatur batas waktu
              penerimaan pesanan, jenis pembatalan sewa, metode pengiriman,
              sesuai dengan opsi-opsi yang tersedia pada pengaturan stok –
              kebijakan sewa.
            </span>
          </li>
          <li>
            <span>
              {" "}
              User memahami sepenuhnya dan menyetujui bahwa segala transaksi
              yang dilakukan antara Vendor dan User selain melalui akun resmi
              Rentrips atau tanpa sepengetahuan Rentrips adalah merupakan
              tanggung jawab pribadi dari Pembeli.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips memiliki kewenangan sepenuhnya untuk menolak pembayaran
              yang dilakukan tanpa pemberitahuan/transaksi terlebih dahulu.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Pembayaran oleh User wajib dilakukan segera, sesuai dengan
              permintaan Vendor pada tata cara sewa yang dicantumkan di halaman
              produk Vendor yang bersangkutan.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Konfirmasi pembayaran dengan setoran tunai wajib disertai dengan
              berita pada slip setoran berupa nomor pesanan dan nama. Konfirmasi
              pembayaran dengan setoran tunai tanpa keterangan tidak akan
              diproses oleh Rentrips.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Dana yang sudah dibayarkan penuh oleh User dapat dikembalikan
              sesuai dengan ketentuan pembatalan sewa yang ditetapkan oleh
              Vendor pada produk yang disewa.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Penyewa menyetujui untuk tidak memberitahukan atau menyerahkan
              bukti pembayaran dan/atau data pembayaran kepada pihak lain selain
              Rentrips. Dalam hal terjadi kerugian akibat pemberitahuan atau
              penyerahan bukti pembayaran dan/atau data pembayaran oleh User
              kepada pihak lain, maka hal tersebut akan menjadi tanggung jawab
              User.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Penyewa wajib melakukan konfirmasi penerimaan Barang, setelah
              menerima kiriman Barang yang disewa. Rentrips memberikan batas
              waktu 48 (empat puluh delapan) jam sejak pengiriman berstatus
              berubah menjadi "terkirim" pada sistem Rentrips untuk dikonfirmasi
              oleh Penyewa. Jika dalam batas waktu tersebut tidak ada konfirmasi
              atau klaim dari pihak penyewa, maka Barang tersebut secara
              otomatis dinyatakan sudah diterima oleh Penyewa dengan kondisi
              sesuai deskripsi.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Penyewa memahami dan menyetujui bahwa setelah Penyewa melakukan
              konfirmasi/konfirmasi otomatis, maka kondisi barang telah diterima
              sesuai deskiripsi listing dan Penyewa bertanggung jawab penuh atas
              kondisi barang yang disewanya.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Setelah adanya konfirmasi penerimaan Barang atau konfirmasi
              penerimaan Barang otomatis, maka dana pihak User yang dikirimkan
              ke Rentrips dikurangi biaya layanan akan dilanjutkan ke pihak
              Vendor dalam waktu 1x24 jam.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Penyewa memahami dan menyetujui bahwa setiap masalah pengiriman
              Barang yang disebabkan keterlambatan pembayaran adalah merupakan
              tanggung jawab dari Penyewa.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips berwenang mengambil keputusan atas
              permasalahan-permasalahan transaksi yang belum terselesaikan
              akibat tidak adanya kesepakatan penyelesaian, baik antara Vendor
              dan User, dengan melihat bukti-bukti yang ada. Keputusan Rentrips
              adalah keputusan akhir yang tidak dapat diganggu gugat dan
              mengikat pihak Vendor dan User untuk mematuhinya.
            </span>
          </li>
          <li>
            <span>
              {" "}
              User wajib melakukan pembayaran dengan nominal yang sesuai dengan
              jumlah tagihan beserta kode unik (apabila ada) yang tertera pada
              halaman pembayaran. Rentrips tidak bertanggungjawab atas kerugian
              yang dialami User apabila melakukan pembayaran yang tidak sesuai.
            </span>
          </li>
          <li>
            <span>
              {" "}
              User memahami sepenuhnya dan menyetujui bahwa ringkasan pesanan
              yang diterbitkan adalah atas nama Vendor.
            </span>
          </li>
        </ol>
        {/** KETENTUAN SEWA */}
        <h3 className=" mt-3">Ketentuan Sewa</h3>
        <ol>
          <li>
            <span>
              Vendor dilarang memanipulasi harga sewa Barang dengan tujuan
              apapun.
            </span>
          </li>
          <li>
            <span>
              Vendor dilarang melakukan penawaran sewa/berdagang Barang
              terlarang lewat Rentrips.
            </span>
          </li>
          <li>
            <span>
              Vendor wajib memberikan foto dan informasi produk dengan lengkap
              dan jelas sesuai dengan kondisi dan kualitas produk yang
              disewakan. Apabila terdapat ketidaksesuaian antara foto dan
              informasi produk yang diunggah oleh Vendor dengan produk yang
              diterima oleh User, maka Rentrips berhak membatalkan/menahan dana
              transaksi.
            </span>
          </li>
          <li>
            <span>
              Dalam menggunakan Fasilitas "Judul Produk", "Foto Produk",
              "Catatan" dan "Deskripsi Produk", Vendor dilarang membuat
              peraturan bersifat klausula baku yang tidak memenuhi peraturan
              perundang-undangan yang berlaku di Indonesia, meliputi; (i) tidak
              menerima komplain, (ii) tidak menerima penukaran barang, (iii)
              tidak menerima refund (pengembalian dana), (iv) pengalihan
              tanggung jawab (termasuk penanggungan ongkos kirim), (v)
              penyusutan nilai harga dan (vi) pengiriman barang acak secara
              sepihak. Jika terdapat pertentangan antara catatan toko dan/atau
              deskripsi produk dengan Syarat &amp; Ketentuan Rentrips, maka
              peraturan yang berlaku adalah Syarat &amp; Ketentuan Rentrips.
            </span>
          </li>
          <li>
            <span>
              Vendor wajib memberikan balasan untuk menerima atau menolak
              pesanan Barang pihak Penyewa dalam batas waktu 24 jam terhitung
              sejak adanya notifikasi pesanan Barang dari Rentrips. Jika dalam
              batas waktu tersebut tidak ada balasan dari Vendor maka secara
              otomatis pesanan akan dibatalkan.
            </span>
          </li>
          <li>
            <span>
              Demi menjaga kenyamanan User dalam bertransaksi, Vendor diharap
              memahami dan menyetujui bahwa Rentrips berhak melakukan review,
              memberi peringatan maupun moderasi toko apabila Vendor melakukan
              penolakan berkali-kali, pembatalan dan/atau sering tidak merespon
              pesanan Barang milik Pembeli dengan dugaan untuk memanipulasi
              transaksi, pelanggaran atas Syarat dan Ketentuan, dan/atau
              kecurangan atau penyalahgunaan lainnya.
            </span>
          </li>
          <li>
            <span>
              Vendor diharapkan untuk memasukkan bukti pengiriman atau nomor
              resi pengiriman Barang yang valid, yaitu: 
            </span>
            <span>
              Tanggal pembuatan resi pengiriman Barang tidak lebih dulu dari
              tanggal transaksi sewa Barang;{" "}
            </span>
            <span>
              Nomor resi pengiriman Barang harus dapat dilacak atau ditemukan
              pada web situs pelacakan;  dan/atau{" "}
            </span>
            <span>
              Merupakan resi pengiriman Barang yang memang diperuntukkan untuk
              User yang akan menerima paket tersebut (detail pengiriman harus
              sama).
            </span>
          </li>
          <li>
            <span>
              Vendor wajib memasukkan nomor resi pengiriman Barang yang valid
              dalam batas waktu 1 x 24 jam (tidak termasuk hari
              Sabtu/Minggu/libur Nasional) terhitung sejak adanya notifikasi
              pesanan Barang dari Rentrips. Apabila Vendor memasukkan nomor resi
              pengiriman Barang yang invalid atau tidak dapat terlacak, Vendor
              wajib memasukkan nomor resi pengiriman Barang yang valid dalam
              batas waktu 1 x 24 jam (tidak termasuk hari Sabtu/Minggu/libur
              Nasional) terhitung sejak adanya notifikasi nomor resi invalid
              atau tidak terlacak yang diberikan oleh Rentrips kepada Vendor.
              Apabila Vendor masih saja tidak mengindahkan Ketentuan yang ada,
              maka pihak Rentrips berhak menyatakan bahwa transaksi yang
              bersangkutan telah dibatalkan.
            </span>
          </li>
          <li>
            <span>
              Vendor memahami dan menyetujui bahwa kurir pengiriman tidak dapat
              diubah oleh Vendor setelah Vendor melakukan konfirmasi pengiriman
              dan sepenuhnya menjadi tanggung jawab Vendor.
            </span>
          </li>
          <li>
            <span>
              Rentrips berwenang mengambil keputusan atas
              permasalahan-permasalahan transaksi yang belum terselesaikan
              akibat tidak adanya kesepakatan penyelesaian, baik antara Vendor
              dan User, dengan melihat bukti-bukti yang ada. Keputusan Rentrips
              adalah keputusan akhir yang tidak dapat diganggu gugat dan
              mengikat pihak Rentrips dan User untuk mematuhinya.
            </span>
          </li>
          <li>
            <span>
              Vendor memahami sepenuhnya dan menyetujui bahwa invoice yang
              diterbitkan adalah atas nama Vendor
            </span>
          </li>
        </ol>
        {/** KETENTUAN SEWA */}
        <h3 className=" mt-3">Jenis Barang</h3>
        <span>
          Berikut ini adalah daftar jenis Barang yang dilarang dan/atau dibatasi
          untuk disewakan oleh Vendor pada Situs Rentrips:
        </span>
        <ol>
          <li>
            <span>
              Segala yang berkaitan dengan alat untuk memakai obat-obatan maupun
              zat-zat lain yang dilarang pada ketentuan Undang-Undang Narkotika,
              Undang-Undang Psikotropika, dan Undang-Undang Kesehatan.
            </span>
          </li>
          <li>
            <span>
              Kosmetik, Perhiasan, Barang Antik, dan alat kecantikan lainnya.
            </span>
          </li>
          <li>
            <span>
              Bahan yang diklasifikasikan sebagai Bahan Berbahaya (Senjata api,
              senjata tajam, senapan angin, dan segala macam senjata), Barang
              yang dapat dan atau mudah meledak, menyala atau terbakar sendiri,
              dan yang kepemilikannya ataupun peredarannya melanggar ketentuan
              hukum yang berlaku di Indonesia.
            </span>
          </li>
          <li>
            <span>
              Barang yang merupakan hasil pelanggaran Hak Cipta, termasuk namun
              tidak terbatas dalam media berbentuk buku, CD/DVD/VCD, informasi
              dan/atau dokumen elektronik, serta media lain yang bertentangan
              dengan Undang-Undang Hak Cipta.
            </span>
          </li>
          <li>
            <span>
              Barang dewasa yang bersifat seksual, alat bantu seks yang
              mengandung konten pornografi, baik yang tidak memiliki izin edar
              BPOM maupun yang peredarannya dibatasi oleh ketentuan hukum yang
              berlaku.
            </span>
          </li>
          <li>
            <span>Pakaian dalam.</span>
          </li>
          <li>
            <span>
              Dokumen pemerintahan dan perjalanan, seragam pemerintahan/atribut
              kepolisian, dan segala hal yang berkaitan dengan kenegaraan.
            </span>
          </li>
          <li>
            <span>Manusia ataupun Bagian/Organ manusia.</span>
          </li>
          <li>
            <span>Mailing list dan informasi pribadi.</span>
          </li>
          <li>
            <span>
              Barang-Barang yang melecehkan pihak/ras tertentu atau dapat
              merendahkan martabat orang lain.
            </span>
          </li>
          <li>
            <span>Pestisida.</span>
          </li>
          <li>
            <span>Barang hasil tindak pencurian.</span>
          </li>
          <li>
            <span>
              Pembuka kunci dan segala aksesori penunjang tindakan
              perampokan/pencurian.
            </span>
          </li>
          <li>
            <span>
              Barang cetakan/rekaman yang isinya dapat mengganggu keamanan &amp;
              ketertiban serta stabilitas nasional.
            </span>
          </li>
          <li>
            <span>Hewan, baik yang hidup maupun yang sudah mati.</span>
          </li>
          <li>
            <span>
              Pengacak sinyal, penghilang sinyal, dan/atau alat-alat lain yang
              dapat mengganggu sinyal atau jaringan telekomunikasi.
            </span>
          </li>
          <li>
            <span>Perlengkapan dan peralatan judi.</span>
          </li>
          <li>
            <span>
              Jimat-jimat maupun benda-benda yang diklaim berkekuatan gaib dan
              memberi ilmu kesaktian.
            </span>
          </li>
          <li>
            <span>
              Produk non fisik yang tidak dapat dikirimkan melalui jasa kurir.
            </span>
          </li>
          <li>
            <span>
              Dokumen-dokumen resmi seperti berbagai Sertifikat (termasuk
              Sertifikat Toefl), Ijazah, Surat Dokter, Kwitansi, dan lain
              sebagainya.
            </span>
          </li>
          <li>
            <span>
              Segala jenis Barang lain yang bertentangan dengan peraturan
              pengiriman Barang Indonesia.
            </span>
          </li>
          <li>
            <span>
              Barang-Barang lain yang melanggar ketentuan hukum yang berlaku di
              Indonesia.
            </span>
          </li>
          <li>
            <span>
              Segala jenis Jasa kecuali untuk penawaran yang berasal dari
              Rentrips dan afiliasinya.
            </span>
          </li>
        </ol>
        {/** Penataan Barang Yang Ditayangkan oleh Vendor */}
        <h3 className=" mt-3">Penataan Barang Yang Ditayangkan oleh Vendor</h3>
        <ol>
          <li>
            <span>
              {" "}
              Vendor dilarang memberikan data kontak pribadi dengan maksud untuk
              melakukan transaksi secara langsung kepada User/calon User.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Vendor dilarang memberikan keterangan tambahan (informasi toko
              dan/atau Barang) selain/diluar daripada keterangan toko dan/atau
              Barang yang bersangkutan.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Penamaan Barang dan informasi produk harus dilakukan sesuai dengan
              informasi detail, spesifikasi, dan kondisi Barang, dengan demikian
              Vendor tidak diperkenankan untuk mencantumkan nama, deskripsi,
              gambar dan/atau kata yang tidak berkaitan dan/atau tidak sesuai
              dengan Barang tersebut.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Vendor yang menambahkan referensi video pada feed Toko yang
              bersumber dari link pihak ketiga (Youtube dan Google) wajib
              mematuhi kebijakan pihak ketiga, dalam hal kebijakan Youtube dan
              Kebijakan Google.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Penamaan Barang dan informasi produk harus sesuai dengan kondisi
              Barang yang ditampilkan dan Pengguna tidak diperkenankan
              mencantumkan nama dan informasi yang tidak sesuai dengan kondisi
              Barang.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips berhak tanpa pemberitahuan sebelumnya untuk melakukan
              pembatalan iklan, penurunan konten dan/atau moderasi toko, apabila
              didapati pelanggaran/manipulasi yang dilakukan oleh Vendor.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Vendor wajib memisahkan tiap-tiap Barang yang memiliki ukuran dan
              harga sewa yang berbeda.
            </span>
          </li>
          <li>
            <span>
              {" "}
              Rentrips memiliki kewenangan mengambil-alih sub-domain toko Vendor
              jika akun Vendor sudah tidak aktif lebih dari 12 bulan.
            </span>
          </li>
        </ol>
        {/** HARGA */}
        <h3 className=" mt-3">Penataan Barang Yang Ditayangkan oleh Vendor</h3>
        <ol>
          <li>
            <span>
              Harga sewa Barang yang terdapat di Rentrips adalah harga yang
              ditetapkan oleh Vendor dan dilarang memanipulasi harga barang
              dengan cara apapun termasuk menetapkan harga sewa yang tidak
              wajar. Jika demikian, Rentrips berhak untuk melakukan pemeriksaan,
              penundaan, atau penurunan konten serta tindakan lainnya
              berdasarkan penilaian sendiri dari Rentrips.
            </span>
          </li>
          <li>
            <span>
              User memahami dan menyetujui bahwa kesalahan keterangan harga dan
              informasi lainnya yang disebabkan tidak terbaharuinya halaman
              Rentrips dikarenakan browser/ISP yang dipakai User adalah tanggung
              jawab User.
            </span>
          </li>
          <li>
            <span>
              User memahami dan menyetujui bahwa kesalahan ketik yang
              menyebabkan keterangan harga atau informasi lain menjadi tidak
              benar/sesuai adalah tanggung jawab Vendor. Apabila terjadi
              kesalahan pengetikan keterangan harga Barang yang tidak disengaja,
              Vendor berhak menolak pesanan Barang.
            </span>
          </li>
          <li>
            <span>
              Setiap masalah dan/atau perselisihan yang terjadi akibat
              ketidaksepahaman antara Vendor dan User mengenai harga bukanlah
              merupakan tanggung jawab Rentrips.
            </span>
          </li>
          <li>
            <span>
              Dengan melakukan pemesanan sewa melalui Rentrips, User menyetujui
              untuk membayar total biaya yang harus dibayarkan sebagaimana
              tertera dalam halaman pembayaran, yang terdiri dari harga sewa
              barang, ongkos kirim, dan biaya-biaya lain yang mungkin timbul dan
              akan diuraikan secara tegas dalam halaman pembayaran, juga setuju
              untuk melakukan pembayaran melalui metode pembayaran yang telah
              dipilih sebelumnya oleh Pengguna.
            </span>
          </li>
          <li>
            <span>
              Vendor berhak mengatur deposit (bila ada) kepada User dan berhak
              juga mengatur nilai besaran deposit tersebut.
            </span>
          </li>
          <li>
            <span>
              Rentrips saat ini hanya melayani transaksi sewa-menyewa dalam mata
              uang Rupiah.
            </span>
          </li>
        </ol>
        {/** RENTSOLVE */}
        <h3 className=" mt-3">Rentsolve</h3>
        <ol>
          <li>
            <span>
              Rentsolve adalah fitur yang disediakan oleh Rentrips untuk
              memfasilitasi penyelesaian masalah transaksi Vendor dan User.
            </span>
          </li>
          <li>
            <span>
              Fitur ini akan secara otomatis menahan dana pembayaran barang ke
              Vendor sampai dengan permasalahan yang dilaporkan ke Rentsolve
              selesai. Pihak Rentrips dapat menarik Dana dari Saldo Rentrips /
              memberikan Saldo minus apabila dalam pelaporan dibuktikan Vendor /
              User bertanggung jawab atas kerugian yang disebabkan oleh
              kerusakan barang, kehilangan barang, dan lainnya.
            </span>
          </li>
          <li>
            <span>
              Dalam menggunakan fitur ini, baik Vendor maupun User diharapkan
              memberikan bukti-bukti transaksi sewa berupa foto barang, bukti
              serah terima barang / checklist, nota pembelian, slip resi
              pengiriman, dan bukti-bukti penunjang lainnya yang dapat menjadi
              dasar pembenar atas setiap argumen yang dikeluarkan oleh
              masing-masing pihak.
            </span>
          </li>
          <li>
            <span>
              Penyelesaian permasalahan melalui Rentsolve dapat berupa solusi
              yang dihasilkan berdasarkan kesepakatan bersama antara Vendor dan
              User.
            </span>
          </li>
          <li>
            <span>
              Jika Vendor tidak memberikan jawaban dalam jangka waktu 2 x 24 jam
              sejak kendala dibuat, maka kendala secara otomatis akan
              terselesaikan berdasarkan solusi yang diajukan oleh User.
            </span>
          </li>
          <li>
            <span>
              Jika tidak ditemukan kesepakatan antara Vendor dan User dalam
              jangka waktu 2 x 24 jam, maka Rentrips memiliki hak untuk membantu
              menyelesaikan kendala.
            </span>
          </li>
          <li>
            <span>
              Vendor dan User menyetujui bahwa Rentrips berwenang untuk
              mengambil keputusan atas permasalahan tersebut dengan melihat
              bukti-bukti yang ada dan/atau bukti-bukti baru yang harus
              dilengkapi masing-masing pihak.
            </span>
          </li>
          <li>
            <span>
              Rentrips berwenang untuk melakukan mediasi dan/atau mengambil
              keputusan untuk penyelesaian masalah di dalam diskusi Rentsolve,
              meskipun salah satu pihak (Vendor maupun User) belum memberikan
              tanggapan atas solusi yang diberikan oleh Rentsolve dalam jangka
              waktu 2 x 24 jam, dalam hal: (i) Adanya informasi dari pihak
              ketiga yang berkaitan dalam jalannya transaksi, yakni antara lain
              kurir pengiriman yang memberikan informasi terkait status terkini
              dari resi pengiriman Barang; (ii) Bukti dari User dan/atau Vendor
              yang dikirimkan melalui jalur komunikasi lain (email Rentrips,
              Layanan Pengguna, dan lainnya) yang perlu diteruskan ke Rentsolve
              dengan dasar transparansi masalah; (iii) Laporan dari salah satu
              pihak disebabkan adanya kelalaian dari Vendor maupun User; (iv)
              Salah satu pihak (Vendor atau User) terindikasi melakukan tindakan
              kecurangan; atau (v) Kondisi tertentu yang menyebabkan Rentrips
              perlu segera melakukan mediasi.
            </span>
          </li>
          <li>
            <span>
              Baik Vendor maupun User memiliki hak untuk banding, dengan
              persyaratan bahwa pihak yang mengajukan upaya banding harus
              mengajukan bukti baru di luar dari bukti-bukti sebelumnya.
            </span>
          </li>
          <li>
            <span>
              Vendor dan User dengan ini menyetujui bahwa Keputusan Rentrips
              atas upaya banding adalah keputusan akhir yang tidak dapat
              diganggu gugat dan mengikat pihak Vendor dan User untuk
              mematuhinya.
            </span>
          </li>
          <li>
            <span>
              Pengguna memahami bahwa Rentsolve tidak berlaku untuk jenis barang
              yang sudah dilarang untuk disewakan di Rentrips seperti yang ada
              di halaman Syarat dan Ketentuan.
            </span>
          </li>
          <li>
            <span>
              Pengguna memahami dan menyetujui bahwa dalam penyelesaian kendala
              di Rentsolve, Vendor dan User wajib memberikan tanggapan atas
              kendala yang ada hingga selesai dengan mematuhi ketentuan dan
              batas waktu sebagaimana yang telah ditentukan pihak Rentrips.
            </span>
          </li>
          <li>
            <span>
              Vendor dan User memahami dan menyetujui bahwa penanggungan ongkos
              kirim yang timbul selama proses penyelesaian kendala pada
              Rentsolve didasarkan oleh bukti-bukti dan/atau kesepakatan yang
              diberikan oleh Vendor dan User. Apabila Vendor dan User tidak
              bersedia untuk menanggung ongkos kirim tersebut, maka Rentrips
              berwenang memberikan keputusan penanggungan ongkos kirim
              berdasarkan perkembangan diskusi dan bukti yang ada.
            </span>
          </li>
          <li>
            <span>
              User memahami dan menyetujui bahwa setelah adanya kesepakatan
              untuk pengiriman Barang kembali ke Vendor, apabila dalam waktu
              maksimal 2 x 24 jam (tidak termasuk hari libur nasional, Sabtu dan
              Minggu) terhitung sejak Vendor memberikan alamat tetapi User tidak
              kunjung melakukan pengiriman barang, maka Rentrips berwenang untuk
              mengambil keputusan berdasarkan perkembangan diskusi dan bukti
              yang ada.
            </span>
          </li>
          <li>
            <span>
              Vendor dan User memahami dan menyetujui bahwa batas waktu untuk
              pemberian bukti adalah maksimal 2 x 24 jam terhitung sejak
              Rentrips melakukan permintaan bukti kepada Vendor dan User atas
              transaksi terkait.
            </span>
          </li>
        </ol>
        {/** Ketentuan Lain */}
        <h3 className=" mt-3">Ketentuan lain</h3>
        <p>
          Segala hal yang belum dan/atau tidak diatur dalam syarat dan ketentuan
          khusus dalam fitur yang ada di Rentrips akan sepenuhnya merujuk pada
          syarat dan ketentuan Rentrips secara umum.
        </p>
        {/** Pelepasan */}
        <h3 className=" mt-3">Pelepasan</h3>
        <p>
          Jika Anda memiliki perselisihan dengan satu atau lebih pengguna, Anda
          melepaskan Rentrips (termasuk Induk Perusahaan, Direktur, dan
          karyawan) dari klaim dan tuntutan atas kerusakan dan kerugian (aktual
          dan tersirat) dari setiap jenis dan sifatnya, yang dikenal dan tidak
          dikenal, yang timbul dari atau dengan cara apapun berhubungan dengan
          sengketa tersebut, termasuk namun tidak terbatas pada kerugian yang
          timbul dari penyewaan Barang yang telah dilarang. Dengan demikian maka
          Pengguna dengan sengaja melepaskan segala perlindungan hukum (yang
          terdapat dalam undang-undang atau peraturan hukum yang lain) yang akan
          membatasi cakupan ketentuan pelepasan ini.
        </p>
        {/** Ganti Rugi */}
        <h3 className=" mt-3">Ganti Rugi</h3>
        <p>
          Pengguna akan melepaskan Rentrips dari tuntutan ganti rugi dan menjaga
          Rentrips (termasuk Induk Perusahaan, direktur, dan karyawan) dari
          setiap klaim atau tuntutan, termasuk biaya hukum yang wajar, yang
          dilakukan oleh pihak ketiga yang timbul dalam hal Anda melanggar
          Perjanjian ini, penggunaan Layanan Rentrips yang tidak semestinya dan/
          atau pelanggaran Anda terhadap hukum atau hak-hak pihak ketiga.
        </p>
        {/** Pilihan Hukum */}
        <h3 className=" mt-3">Pilihan Hukum</h3>
        <p>
          Perjanjian ini akan diatur oleh dan ditafsirkan sesuai dengan hukum
          Republik Indonesia, tanpa memperhatikan pertentangan aturan hukum.
          Anda setuju bahwa tindakan hukum apapun atau sengketa yang mungkin
          timbul dari, berhubungan dengan, atau berada dalam cara apapun
          berhubungan dengan situs dan/atau Perjanjian ini akan diselesaikan
          secara eksklusif dalam yurisdiksi pengadilan Republik Indonesia.
        </p>
        {/** Pembaharuan */}
        <h3 className=" mt-3">Pembaharuan</h3>
        <p>
          Syarat & ketentuan mungkin diubah dan/atau diperbaharui dari waktu ke
          waktu tanpa pemberitahuan sebelumnya. Rentrips menyarankan agar anda
          membaca secara seksama dan memeriksa halaman Syarat & ketentuan ini
          dari waktu ke waktu untuk mengetahui perubahan apapun. Dengan tetap
          mengakses dan menggunakan layanan Rentrips, maka pengguna dianggap
          menyetujui perubahan-perubahan dalam Syarat & Ketentuan.
        </p>
        {/** Ketentuan Lain */}
        <h3 className=" mt-3">Ketentuan lain</h3>
        <p>
          Segala hal yang belum dan/atau tidak diatur dalam syarat dan ketentuan
          khusus dalam fitur yang ada di Rentrips akan sepenuhnya merujuk pada
          syarat dan ketentuan Rentrips secara umum.
        </p>
      </div>
    );
  };

  const renderTags = () => {
    return (
      <div className="max-w-screen-md mx-auto flex flex-wrap">
        <ButtonPrimary
          className="nc-Tag inline-block text-sm text-neutral-600 py-2 rounded-lg border border-neutral-100  md:px-4 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
          href="/"
        >
          Kembali ke beranda
        </ButtonPrimary>
      </div>
    );
  };

  return (
    <div className="nc-PageSingle pt-8 lg:pt-16 pb-32">
      <Helmet>
        <title>Single Blog</title>
      </Helmet>
      <div className="nc-SingleContent container space-y-10">
        {renderContent()}
        {renderTags()}
      </div>
      <ButtonTop />
    </div>
  );
};

export default SnKPost;
